
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/events/detail",
      function () {
        return require("private-next-pages/locale/events/detail.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/events/detail"])
      });
    }
  